import GoogleMap from 'google-map-react';
import * as React from 'react';
import { PushPin } from './MapComponents'; 

interface IProps {
    center      : any;
    onClick?    : any;
}

export const AddressMapDisplay = (props : IProps) => {
    
    const onClick = (e : any) => {
        if (props.onClick) {
            props.onClick(e.lat, e.lng);
        }        
    };
    
    return <GoogleMap                  
                bootstrapURLKeys={{ key : 'AIzaSyAkD-OQdo2Y7Y0TlSDorQLUwDrjfyLXUFI'}}
                center={ props.center }
                zoom={ 13 }
                onClick={ onClick }
                margin={[30, 30, 30, 30]}
                hoverDistance={30}>
                    <PushPin 
                        lat={ props.center.lat } 
                        lng={ props.center.lng } />
            </GoogleMap>;
};
